import { HelloWorldWidgetComponent } from '../components/widgets/hello-world/hello-world.component';
import { DatatableWidgetComponent } from '../components/widgets/datatable/datatable.component';
import { PlainHtmlComponent } from '../components/widgets/plain-html/plain-html.component';

export const Widgets = [
  HelloWorldWidgetComponent,
  DatatableWidgetComponent,
  PlainHtmlComponent,
];
